import { Box, Link } from "@mui/material";
import {
  Datagrid,
  List,
  ShowButton,
  TextField,
  FunctionField,
  RaRecord,
} from "react-admin";
import { getReferenceName } from "../../utils/walletTransactionReference";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
  { type: "text", label: "Reference Id", source: "referenceId" },
  {
    type: "select",
    label: "Reference Model Name",
    source: "referenceModelName",
    minWidth: 220,
    options: ['ONE_MEAL_SERVICE', 'CHEF_FOR_PARTY'].map((value) => ({
      value,
      label: value,
    })),
  },
];

const VendorTipList = (props: any) => {
  return (
    <List
      {...props}
      sort={{ field: 'createdAt', order: 'DESC' }}
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      }}
    >
      <>
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Vendor Tips">
      <Datagrid bulkActionButtons={false} sx={commonDatagridSx}>
        <TextField source="id" sortable={false} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Cook Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/Cooks/${record?.cookId}/show`}>
                    {record?.cookId}
                </Link>
                );
        }} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Customer Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/Customers/${record?.customerId}/show`}>
                    {record?.customerId}
                </Link>
                );
        }} />
        <TextField source="amount" sortable={false} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Reference Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/${getReferenceName(record?.referenceModelName)}/${record?.referenceId}/show`}>
                    {record?.referenceId}
                </Link>
                );
        }} />
        <TextField source="referenceModelName" sortable={false} />
        <TextField source="status" sortable={false} />
        <FunctionField
            label="Action"
            render={() => {
              return (
                <Box sx={{ display: "flex" }}>
                  <ShowButton />
                </Box>
              );
            }}
        />
      </Datagrid>
      </StyledDatagridWrapper>
      </>
    </List>
  );
};
export default VendorTipList;